import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import LoaderComponent from "../Loader.js";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import { CheckCircle, Error }  from '@material-ui/icons';
import copyFilesModalStyle from "../../../assets/jss/user/copyFilesModalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const DownloadProcessModal = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        
        const { downloads = [] } = this.props;
        const activeDownloads = downloads.filter(dl => dl.status === 'downloading') || [];
        
        this.state = {
            activeDownloads: [...activeDownloads],
            downloads: [...downloads],
            downloadUrl: '',
            canceled: false,
            errorMessage: null,
            cancelTokens: {},
            showLists: true,
        };
        
        this.activeDownloadPromises = {};
        
        this.startDownloads = this.startDownloads.bind(this);
        this.updateDownloadStatus = this.updateDownloadStatus.bind(this);
        this.downloadFiles = this.downloadFiles.bind(this);
        this.processSingleDownload = this.processSingleDownload.bind(this);
        this.removeFromActiveDownloads = this.removeFromActiveDownloads.bind(this);
        this.trackFileDownload = this.trackFileDownload.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleToggleFiles = this.handleToggleFiles.bind(this);
    }
    componentDidMount() {
        this.startDownloads(this.props.downloads);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.downloads.length > prevProps.downloads.length) {
            this.startDownloads(this.props.downloads);
        }
        
        if (!prevState.canceled && this.state.canceled) {
            setTimeout(() => {
                this.props.onClose();
            }, 1000);
        }
        
        // Check if all downloads are completed
        const allCompleted = this.state.downloads.every(dl => 
            ['completed', 'error', 'cancelled'].includes(dl.status)
        );
        
        if (allCompleted && this.state.downloads.length > 0) {
            setTimeout(() => {
                if (this.props.onClose) {
                    this.props.onClose();
                }
            }, 1000);
        }
    }
    componentWillUnmount() {
        const { cancelTokens } = this.state;
        Object.values(cancelTokens).forEach(token => {
            if (token) {
                token.cancel('Component unmounted');
            }
        });
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If no previous state or downloads, initialize with new props
        if (!prevState.downloads || prevState.downloads.length === 0) {
            const initialDownloads = nextProps.downloads.map(dl => ({
                ...dl,
                downloadId: dl.downloadId || dl.id || `dl-${Date.now()}`,
                status: dl.status || 'pending',
                error: dl.error || null,
                completedAt: dl.completedAt || null,
                timestamp: dl.timestamp || new Date().toISOString(),
                fileCount: dl.fileCount || (dl.files ? dl.files.length : 0)
            }));
            
            return {
                downloads: initialDownloads,
                activeDownloads: initialDownloads.filter(dl => dl.status === 'downloading')
            };
        }

        // Check for new downloads
        if (nextProps.downloads.length > prevState.downloads.length) {
            // Find new downloads that aren't in the current state
            const newDownloads = nextProps.downloads.filter(newDl => 
                !prevState.downloads.some(oldDl => oldDl.downloadId === (newDl.downloadId || newDl.id))
            );

            if (newDownloads.length > 0) {
                // Initialize new downloads with proper structure
                const initializedNewDownloads = newDownloads.map(dl => ({
                    ...dl,
                    downloadId: dl.downloadId || dl.id || `dl-${Date.now()}`,
                    status: dl.status || 'pending',
                    error: dl.error || null,
                    completedAt: dl.completedAt || null,
                    timestamp: dl.timestamp || new Date().toISOString(),
                    fileCount: dl.fileCount || (dl.files ? dl.files.length : 0)
                }));

                // Merge with existing downloads
                const updatedDownloads = [
                    ...prevState.downloads,
                    ...initializedNewDownloads
                ];

                return {
                    downloads: updatedDownloads,
                    activeDownloads: [
                        ...prevState.activeDownloads.filter(ad => ad.status === 'downloading'),
                        ...initializedNewDownloads
                    ]
                };
            }
        }


        // Handle updates to existing downloads
        const updatedDownloads = nextProps.downloads.map(newDl => {
            const existing = prevState.downloads.find(dl => 
                dl.downloadId === (newDl.downloadId || newDl.id)
            );
            return existing ? { ...existing, ...newDl } : newDl;
        });

        return {
            downloads: updatedDownloads,
            activeDownloads: prevState.activeDownloads
        };
    }
    startDownloads(allDownloads) {
        const { activeDownloads = [] } = this.state || {};
        
        // Filter out any completed/failed downloads from activeDownloads
        const activeDownloading = activeDownloads.filter(ad => 
            ad.status === 'downloading' && 
            !this.activeDownloadPromises[ad.downloadId]
        );
        
        // Find all pending downloads that aren't already being downloaded
        const downloadsToStart = allDownloads.filter(dl => 
            dl.status === 'pending' && 
            !activeDownloading.some(ad => ad.downloadId === dl.downloadId)
        );
        
        if (downloadsToStart.length === 0) {
            // Check if all downloads are completed
            const allCompleted = allDownloads.every(dl => 
                ['completed', 'error', 'cancelled'].includes(dl.status)
            );
            
            if (allCompleted && allDownloads.length > 0) {
                setTimeout(() => {
                    if (this.props.onClose) {
                        this.props.onClose();
                    }
                }, 1000);
            }
            return;
        }
        
        // Update state with new downloads
        const updatedDownloads = allDownloads.map(dl => {
            const downloadToStart = downloadsToStart.find(d => d.downloadId === dl.downloadId);
            return downloadToStart ? { ...dl, status: 'downloading' } : dl;
        });
        
        const newActiveDownloads = [
            ...activeDownloading,
            ...downloadsToStart.map(dl => ({ ...dl, status: 'downloading' }))
        ];
        
        this.setState({
            downloads: updatedDownloads,
            activeDownloads: newActiveDownloads
        }, () => {
            // Start the downloads
            downloadsToStart.forEach(download => {
                if (!this.activeDownloadPromises[download.downloadId]) {
                    this.downloadFiles(download);
                }
            });
        });
    }
    
    updateDownloadStatus(downloadId, status, error = null) {        
        this.setState(prevState => {
            // Create a deep copy of the downloads array to avoid mutating the state directly
            const updatedDownloads = prevState.downloads.map(dl => ({...dl}));
            let downloadIndex = updatedDownloads.findIndex(dl => dl.downloadId === downloadId);
            
            if (downloadIndex === -1) return null;
            
            // Create an updated download object
            const updatedDownload = { 
                ...updatedDownloads[downloadIndex],
                status,
                ...(error !== null && { error })
            };
            
            if (status === 'completed') {
                updatedDownload.completedAt = new Date().toISOString();
                updatedDownload.completedCount = updatedDownload.fileCount || 1;
            }
            
            // Update the download in the array
            updatedDownloads[downloadIndex] = updatedDownload;
            
            // Update activeDownloads
            let newActiveDownloads = prevState.activeDownloads;
            
            if (['completed', 'error', 'cancelled'].includes(status)) {
                // Remove from active downloads if completed or failed
                newActiveDownloads = prevState.activeDownloads.filter(
                    dl => dl.downloadId !== downloadId
                );
            } else {
                // Update the download in activeDownloads
                newActiveDownloads = prevState.activeDownloads.map(dl => 
                    dl.downloadId === downloadId ? updatedDownload : dl
                );
            }
            
            console.log("UPDATE_STATE", status);
            this.props.store.dispatch({
                type: 'UPDATE_STATE',
                state: {
                    downloadProcessState: {
                        ...this.props.store.getState().downloadProcessState,
                        downloads: updatedDownloads,
                        activeDownloads: newActiveDownloads,
                        downloadProcessModal: true
                    }
                }
            });
            
            return {
                downloads: updatedDownloads,
                activeDownloads: newActiveDownloads
            };
        });
    }
    
    async downloadFiles(download) {
        if (!download || !download.files || download.files.length === 0) {
            this.updateDownloadStatus(download.downloadId, 'error', 'No files to download');
            this.removeFromActiveDownloads(download.downloadId);
            return Promise.reject('No files to download');
        }
        
        // Update status to downloading if not already
        if (download.status !== 'downloading') {
            this.updateDownloadStatus(download.downloadId, 'downloading');
        }
        
        try {
            // Process the download
            await this.processSingleDownload(download);
            
            // Check if the download wasn't cancelled before marking as completed
            const currentDownload = this.state.downloads.find(dl => dl.downloadId === download.downloadId);
            if (currentDownload?.status !== 'cancelled') {
                this.updateDownloadStatus(download.downloadId, 'completed');
                // Start any pending downloads
                this.startDownloads(this.props.downloads);
            }
        } catch (error) {
            // Only update status if it's not already cancelled
            const currentDownload = this.state.downloads.find(dl => dl.downloadId === download.downloadId);
            if (currentDownload?.status !== 'cancelled') {
                console.error('Download error:', error);
                this.updateDownloadStatus(
                    download.downloadId, 
                    'error', 
                    error.message || 'Download failed'
                );
            }
            
            // Re-throw the error to maintain the promise chain
            throw error;
        } finally {
            // Always remove from active downloads when done
            this.removeFromActiveDownloads(download.downloadId);
            
            // Start any pending downloads
            this.startDownloads(this.props.downloads);
        }
    }
    
    processSingleDownload(download) {
        if (!download || !download.files || download.files.length === 0) {
            return Promise.reject('No files to download');
        }
        
        // Update the download status to 'downloading' in both state and Redux
        this.updateDownloadStatus(download.downloadId, 'downloading');
        
        const cancelToken = axios.CancelToken.source();
        const requestData = {
            files: download.files.map(file => file.id || file),
            path: download.path || '/',
            file_id: download.shareFileId,
        };
        
        // Update component state with the cancel token
        this.setState(prevState => ({
            cancelTokens: {
                ...prevState.cancelTokens,
                [download.downloadId]: cancelToken
            }
        }));
        
        // Start the download
        return Api.downloadFiles(requestData, cancelToken, (progressEvent) => {
            // Progress updates can be handled here if needed
            // We're not updating status on progress to avoid too many re-renders
        })
        .then(response => {
            // Check if download was cancelled before processing the response
            const currentDownload = this.state.downloads.find(dl => dl.downloadId === download.downloadId);
            if (currentDownload?.status === 'cancelled') {
                console.log('Download was cancelled, not marking as completed');
                return;
            }

            if (response && response.downloadUrl) {
                this.trackFileDownload(download);
                
                const link = document.createElement('a');
                link.href = response.downloadUrl;
                link.download = download.files.length === 1 ? download.files[0].name : 'download.zip';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                if (currentDownload?.status !== 'cancelled') {
                    this.updateDownloadStatus(download.downloadId, 'completed');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        })
        .catch(error => {
            const errorStatus = axios.isCancel(error) ? 'cancelled' : 'error';
            const errorMessage = axios.isCancel(error) 
                ? 'Download cancelled by user' 
                : error.message || 'Download failed';
                
            if (errorStatus === 'error') {
                console.error('Download error:', error);
            }
            
            this.updateDownloadStatus(download.downloadId, errorStatus, errorMessage);
        })
        .finally(() => {
            // Clean up and process next download
            this.removeFromActiveDownloads(download.downloadId);
        });
    }
    
    removeFromActiveDownloads(downloadId) {
        // Clean up the download promise
        if (this.activeDownloadPromises[downloadId]) {
            delete this.activeDownloadPromises[downloadId];
        }
        
        // Update active downloads in state
        this.setState(prevState => ({
            activeDownloads: prevState.activeDownloads.filter(dl => dl.downloadId !== downloadId),
            cancelTokens: Object.fromEntries(
                Object.entries(prevState.cancelTokens).filter(([id]) => id !== downloadId)
            )
        }));
    }
    
    trackFileDownload(download) {
        if (!download || !download.files || download.files.length === 0) {
            return Promise.resolve();
        }
        
        const source = axios.CancelToken.source();
        const requestData = {
            id: download.files.map(file => file.id),
            file_id: download.shareFileId,
        };
        
        return Api.trackFileDownload(requestData, source)
            .then(() => {})
            .catch(() => {});
    }
    onCancel() {
        const { cancelTokens, downloads } = this.state;
        
        Object.values(cancelTokens).forEach(token => {
            if (token) {
                token.cancel('Download cancelled by user');
            }
        });

        const updatedDownloads = downloads.map(dl => 
            dl.status === 'downloading' || dl.status === 'pending'
                ? { ...dl, status: 'cancelled', error: 'Download cancelled by user' }
                : dl
        );
        
        this.setState({
            downloads: updatedDownloads,
            cancelTokens: {},
            activeDownloads: [],
            showError: false,
            errorMessage: 'Download cancelled',
            canceled: true
        });
    }
    handleToggleFiles(){
        this.setState({
            showLists: !this.state.showLists
        })
    }
    render() {
        const { classes } = this.props;
        const { downloads = [], activeDownload, downloadUrl, canceled, showLists } = this.state;
        
        const currentDownload = activeDownload || downloads.find(dl => dl.status === 'pending' || dl.status === 'downloading');
        const isProcessing = currentDownload?.status === 'downloading' || currentDownload?.status === 'pending';
        const isDownloading = currentDownload?.status === 'downloading';
        const isPreparing = currentDownload?.status === 'pending';
        const isCompleted = currentDownload?.status === 'completed';
        const hasError = currentDownload?.status === 'error';
        const isCanceled = currentDownload?.status === 'cancelled' || canceled;
        
        return (
            <div className={classes.copyFilesProgress}>
                <p className='copied-files-header' onClick={() => this.handleToggleFiles()}>
                    {
                        downloadUrl !== ''
                            ? 'Download Ready'
                            : isDownloading
                            ? 'Downloading...'
                            : isPreparing
                            ? 'Preparing download...'
                            : isCompleted
                            ? 'Download Complete'
                            : hasError
                            ? 'Download Failed'
                            : isCanceled
                            ? 'Download Cancelled'
                            : 'Download'
                    }
                </p>
                {
                    !canceled && downloadUrl === '' && isProcessing ?
                        <div className={'copied-files-detail ' + (showLists ? 'show' : 'hide')}>
                            <p className='cancel' onClick={() => this.onCancel()}>Cancel</p>
                        </div>
                    :
                        <></>
                }
                <div className={'files-listings ' + (showLists ? 'show' : 'hide')}>
                    <ul>
                        {downloads.map((download, index) => {
                            const fileCount = download.files?.length || 0;
                            
                            return (
                                <li key={download.downloadId || index}>
                                    <div className='file-info'>
                                        <Button justIcon color="transparent" className={classes.fileIcon}>
                                            <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM3.75 1.875C3.75 1.53125 4.03125 1.25 4.375 1.25H5.625C5.96875 1.25 6.25 1.53125 6.25 1.875C6.25 2.21875 5.96875 2.5 5.625 2.5H4.375C4.03125 2.5 3.75 2.21875 3.75 1.875ZM3.75 4.375C3.75 4.03125 4.03125 3.75 4.375 3.75H5.625C5.96875 3.75 6.25 4.03125 6.25 4.375C6.25 4.71875 5.96875 5 5.625 5H4.375C4.03125 5 3.75 4.71875 3.75 4.375ZM3.75 6.875C3.75 6.53125 4.03125 6.25 4.375 6.25H5.625C5.96875 6.25 6.25 6.53125 6.25 6.875C6.25 7.21875 5.96875 7.5 5.625 7.5H4.375C4.03125 7.5 3.75 7.21875 3.75 6.875ZM3.50391 9.67969C3.64844 9.13281 4.14453 8.75 4.71094 8.75H5.28906C5.85547 8.75 6.35156 9.12891 6.49609 9.67969L7.41406 13.125C7.46875 13.3359 7.49609 13.5508 7.49609 13.7656C7.49609 15.1406 6.37109 16.2539 4.99609 16.2539C3.62109 16.2539 2.49609 15.1406 2.49609 13.7656C2.49609 13.5508 2.52344 13.332 2.57812 13.125L3.49609 9.67969H3.50391ZM4.375 13.125C4.03125 13.125 3.75 13.4062 3.75 13.75C3.75 14.0938 4.03125 14.375 4.375 14.375H5.625C5.96875 14.375 6.25 14.0938 6.25 13.75C6.25 13.4062 5.96875 13.125 5.625 13.125H4.375Z" fill="#4A4A4A"/>
                                            </svg>
                                        </Button>
                                        <div className='file-details'>
                                            <span className='name'>
                                                {fileCount} {fileCount > 1 ? 'files' : 'file'} {
                                                    download.status === 'completed' ? 'Zipped' : 
                                                    download.status === 'downloading' ? 'Zipping' : 
                                                    download.status === 'cancelled' ? 'Cancelled' :
                                                    download.status === 'error' ? 'Failed' :
                                                    'Pending'
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    {
                                        download.status === 'completed' ?
                                            <CheckCircle className={classes.icons} />
                                        : download.status === 'downloading' ?
                                            <LoaderComponent color="custom" align="center" />
                                        : download.status === 'error' ?
                                            <Error className={classes.icons} />
                                        : 
                                            null
                                    }
                                </li>
                            );
                        })}
                    </ul>
                </div>
                
                {downloadUrl && (
                    <iframe 
                        src={downloadUrl} 
                        style={{ display: 'none' }}
                        title="download"
                    />
                )}
            </div>
        );
    }
}

DownloadProcessModal.defaultProps = {
    open: false,
    downloadId: null
}
DownloadProcessModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    downloadId: PropTypes.number,
    files: PropTypes.array.isRequired,
    path: PropTypes.string.isRequired,
    shareFileId: PropTypes.string,
    store: PropTypes.object.isRequired
}
export default withStyles(copyFilesModalStyle)(DownloadProcessModal);